module.exports = __webpack_public_path__ + "static/img/energy-drink.08a5284.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/energy-drink.png
// module id = 7Zs0
// module chunks = 0